import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import axios from '../../../services/MyAxios';

import { CASINO_GAME_CATEGORY_BLOCKS } from '../Helpers/CrmUrls';

import GameCategoryForm from './GameCategoryBlockForm';

import SweetAlert from 'crm/elements/alerts/SweetAlert';

function GameCategoryBlockCreate() {
    const [errors, setErrors] = useState([]);
    const [translationErrors, setTranslationsErrors] = useState([]);
    const history = useHistory();
    const url = '/crea/casino/api/game-category-blocks/create';

    const handleSubmit = (gameCategory) => {
        axios
            .post(url, gameCategory)
            .then(() => {
                SweetAlert.success('Game category block correctly').then(() => {
                    history.push({ pathname: CASINO_GAME_CATEGORY_BLOCKS });
                });
            })
            .catch((error) => {
                if (!error.response) {
                    setErrors(error.message);
                } else if (error.response.status !== 500) {
                    setTranslationsErrors(error.response.data.errors.translations);
                    if (
                        error.response.data.errors.translations &&
                        error.response.data.errors.translations[0].hasOwnProperty('language_id')
                    ) {
                        error.response.data.errors.translations = undefined;
                    }
                    setErrors(error.response.data.errors);
                } else {
                    SweetAlert.error('Server error');
                }
            });
    };

    return <GameCategoryForm handleSubmit={handleSubmit} errors={errors} translationErrors={translationErrors} />;
}

export default GameCategoryBlockCreate;
